import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderConfirmationItem } from '../interface';

@Component({
  selector: 'app-change-price-dialog',
  templateUrl: './change-price-dialog.component.html',
  styleUrls: ['./change-price-dialog.component.scss'],
  standalone: false,
})
export class ChangePriceDialogComponent {
  currentSpendAmountInCents: number;

  constructor(
    public dialogRef: MatDialogRef<ChangePriceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { item: OrderConfirmationItem },
  ) {
    if (data?.item?.generalPriceInfo?.price) {
      this.currentSpendAmountInCents = data.item.generalPriceInfo.price;
    }
    dialogRef.disableClose = true;
  }

  handleOutputFromVariablePriceInputComponent(outputPriceInCents): void {
    if (!outputPriceInCents || typeof outputPriceInCents === 'object') {
      return null;
    }

    this.currentSpendAmountInCents = outputPriceInCents;
  }

  closeDialog(): void {
    this.dialogRef.close(this.currentSpendAmountInCents);
  }
}
